import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import NewsletterCTA from './components/NewsletterCTA';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'h漫导航',
  url: 'https://hmanga.example.com',
  description: '探索h漫的世界，汇聚海量h漫资源、风格分类与创作背景介绍。专业h漫导览、热门推荐及文化解读。',
  potentialAction: {
    '@type': 'SearchAction',
    'target': 'https://hmanga.example.com/category/japanese?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'h漫导航',
  url: 'https://hmanga.example.com',
  description: '精选h漫资源导航与推荐平台',
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <FeaturedArticles />
          <LatestArticles />
          <NewsletterCTA />
        </main>
        <Footer />
      </div>
    </>
  );
}